import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Field } from "@/components/common";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { roleOf } from "@/lib/constants";
import { LOGIN } from "@/constants/testIds/auth";
import AuthLayout from "./AuthLayout";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ email: "", password: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      const u = await login(f);
      nav(roleOf(u) === "super_admin" ? "/admin" : "/dashboard");
    } catch (ex) {
      setErr(errMsg(ex));
    } finally {
      setBusy(false);
    }
  };
  return (
    <AuthLayout title="Welcome back" subtitle="Sign in with the email and password your clinic gave you.">
      <form onSubmit={submit} className="space-y-5">
        <Field label="Email"><Input type="email" required value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid={LOGIN.emailInput} /></Field>
        <Field label="Password"><Input type="password" required value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} data-testid={LOGIN.passwordInput} /></Field>
        {err && <p className="text-sm text-rose-600" data-testid="login-error">{err}</p>}
        <Button type="submit" disabled={busy} className="w-full rounded-full h-11" data-testid={LOGIN.submitButton}>{busy ? "Signing in…" : "Sign in"}</Button>
        <p className="text-sm text-slate-500">Running a clinic group? <Link to="/register" className="font-semibold text-teal-700" data-testid={LOGIN.registerLink}>Register as CEO / MD</Link></p>
      </form>
    </AuthLayout>
  );
}
